export default __webpack_public_path__ + "static/image2-c6a2667acf061bb80be6a251e5c3f76f.png";